module.exports = __webpack_public_path__ + "img/deef787.webp";